module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#action",
      toString: function () {
        return this.url;
      }
    }